<div class="thumbnail" *ngIf="reference">
  <img *ngIf="thumbnail" [src]="thumbnail" (click)="openModal()" />
  <div class="text-center" *ngIf="loading">
    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">{{ reference.title }}</h4>
  </div>
  <div class="modal-body text-center">
    <img *ngIf="image" [src]="image" />
    <div *ngIf="modalLoading">
      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>
